import { ROLE_HIERARCHY } from '@app/permissions/role-hierarchy';
import { Role } from '@app/utils/protected-routes.utils';

export interface RoleData {
  id: Role;
  name: string;
  description: string;
  label: string;
}

export const roles: RoleData[] = [
  {
    id: Role.ADMIN,
    name: 'ADMIN',
    description: ROLE_HIERARCHY[Role.ADMIN].description,
    label: ROLE_HIERARCHY[Role.ADMIN].displayName,
  },
  {
    id: Role.INVESTIGATOR,
    name: 'INVESTIGATOR',
    description: ROLE_HIERARCHY[Role.INVESTIGATOR].description,
    label: ROLE_HIERARCHY[Role.INVESTIGATOR].displayName,
  },
  {
    id: Role.REVIEWER,
    name: 'REVIEWER',
    description: ROLE_HIERARCHY[Role.REVIEWER].description,
    label: ROLE_HIERARCHY[Role.REVIEWER].displayName,
  },
] as const;
